<template>
  <vi-page>
    <div v-if="showList">
      <div class="mb-2">
        <button type="reset" class="btn btn-primary mr-2" @click="eAddable">
          开通账号
        </button>
        <div class="mt-4"><span class="text-danger">*</span>{{ text }}</div>
      </div>
    </div>

    <div v-else>
      <div class="account_menu_card" v-if="copyShow">
        <div class="row_flex">
          <div>手机号：{{ accountMobileText }}</div>
          <div>邮箱：{{ accountEmailText }}</div>
          <div>密码：{{ passwordText }}</div>
          <div></div>
        </div>
        <span class="text-danger">* 请妥善保管好账号密码！！！</span>
        <span class="menu_copy" @click="eCopy">
          <vi-icon :name="icon"></vi-icon>
        </span>
      </div>

      <div class="account_menu_card">
        <div class="account_menu_card-title">基本信息</div>
        <div>注册类型：{{ accountList.registerTypeText }}</div>
        <div>创建人：{{ accountList.creatorSNText }}</div>
        <div>创建时间：{{ accountList.timeText }}</div>
      </div>
      <div class="account_menu_card">
        <div class="account_menu_card-title">账号状态</div>
        <div class="row_flex">
          <div :style="{ color: accountList.activeStatusText.color }">
            {{ accountList.activeStatusText.name }}
          </div>
          <div class="row_change">
            <span
              v-if="accountList.activeStatusText != 'Forbidden'"
              @click="eBan()"
              >停用</span
            >
            <span
              v-if="accountList.activeStatusText != 'Forbidden'"
              @click="eRecovery()"
              >恢复</span
            >
            <!-- <span @click="eDisable()">永久禁用</span> -->
          </div>
        </div>
        <div class="row_flex">
          <div>激活时间：{{ accountList.activeTimeText }}</div>
          <div>最近登录时间：{{ accountList.lastTime }}</div>
          <div></div>
        </div>
        <div>过期时间：{{ accountList.expiredTime }}</div>
      </div>
      <div class="account_menu_card">
        <div class="account_menu_card-title">账号</div>
        <div class="row_flex">
          <div>{{ accountList.account }}</div>
          <div class="row_change"><span @click="eChange()">修改</span></div>
        </div>
      </div>
      <div class="account_menu_card">
        <div class="account_menu_card-title">手机号</div>
        <div class="row_flex">
          <div>{{ accountList.mobile }}</div>
          <!-- <div class="row_change">
            <span @click="eChange()">重新绑定</span>
          </div> -->
        </div>
      </div>
      <div class="account_menu_card">
        <div class="account_menu_card-title">邮箱</div>
        <div class="row_flex">
          <div>{{ accountList.email }}</div>
          <!-- <div class="row_change">
            <span @click="eChange()">重新绑定</span>
          </div> -->
        </div>
      </div>
      <div class="account_menu_card">
        <div class="account_menu_card-title">密码</div>
        <div class="row_flex">
          <div>当前密码强度：{{ accountList.passwordComplexityTypeText }}</div>
          <div>累计连续错误次数：{{ accountList.passwordErrorCount }}</div>
          <div class="row_change">
            <span @click="eReset()">重置密码</span>
          </div>
        </div>
        <div class="row_flex">
          <div>密码状态：{{ accountList.passwordStatusText }}</div>
          <div>当天连续错误次数：{{ accountList.todayPasswordErrorCount }}</div>
          <div></div>
        </div>
        <div class="row_flex">
          <div>最近修改时间：{{ accountList.passwordTime }}</div>
          <div>最后错误时间：{{ accountList.todayPasswordErrorTime }}</div>
          <div></div>
        </div>
      </div>
      <div class="account_menu_card">
        <div class="account_menu_card-title">密码策略</div>
        <div class="row_flex">
          过期时间（密码过期后，用户须重新取回密码后才可重新登录）：{{
            accountList.passwordExpiredTime
          }}
          <!-- <div class="row_change">
            <span @click="eChange()">重新绑定</span>
          </div> -->
        </div>
        <div>
          必须修改时间（用户必须修改密码后，才可重新登录）：{{
            accountList.passwordModifyTime
          }}
        </div>
      </div>

      <div class="menu_table">
        <div>账号行为日志</div>
        <table class="table table-head-custom table-vertical-center">
          <thead>
            <tr>
              <th>添加时间</th>
              <th>风险级别</th>
              <th>事件行为</th>
              <th>内容</th>
              <th>操作人</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <VCCustomerAddModalCtrl
      v-if="modalData.addable"
      v-model="modalData.showAdd"
      :modalCustomerData="modalData"
      :type="addType"
      @input="eModalCancel"
      @e-confirm="eModalConfirm"
      @e-cancel="eModalCancel"
    />
    <vi-modal
      v-if="addable"
      v-model="showAdd"
      :title="addModelTitle"
      size="sm"
      @e-cancel="addCancel"
      @e-confirm="addConfirm"
    >
      <input
        type="text"
        name=""
        id=""
        v-model="accountVal"
        class="form-control"
      />
    </vi-modal>
    <AccountPasswordResetCtrl
      v-if="reset.addable"
      v-model="reset.showAdd"
      :modalData="reset"
      @input="eResetCancel"
      @e-confirm="eResetConfirm"
      @e-cancel="eResetCancel"
    />
  </vi-page>
</template>

<script>
var moment = require("moment");
import VCCustomerAddModalCtrl from "@/controls/customer/CustomerAddModalCtrl";
import AccountPasswordResetCtrl from "@/controls/customer/AccountPasswordResetCtrl";
export default {
  name: "AccountAdd",
  components: {
    VCCustomerAddModalCtrl,
    AccountPasswordResetCtrl,
  },
  data() {
    return {
      cusUserSN: "",
      accountList: {
        registerTypeText: "",
        creatorSNText: "",
        timeText: "",
        activeStatusText: {},
        activeTimeText: "",
        expiredTime: "",
        lastTime: "",
        account: "",
        mobile: "",
        email: "",
        passwordComplexityTypeText: "",
        passwordStatusText: "",
        passwordTime: "",
        passwordErrorCount: "",
        todayPasswordErrorCount: "",
        todayPasswordErrorTime: "",
        passwordExpiredTime: "",
        passwordModifyTime: "",
        sn: "",
      },
      addable: false,
      showAdd: true,
      addModelTitle: "修改账号",
      accountVal: "",
      modalData: {
        addable: false,
        showAdd: true,
        addModelTitle: "开通账号",
        modalSize: "md",
        modalType: 1,
        name: "",
        formShow: true,
      },
      reset: {
        addable: false,
        reset: false,
        formShow: true,
      },
      fields: [
        {
          name: "account",
          type: "text",
          label: "账号",
          maxlength: 64,
          validation: {
            items: [{ type: "Required", invalid: "该项必填" }],
          },
        },
        {
          name: "mobile",
          type: "text",
          label: "手机号",
          maxlength: 64,
        },
        {
          name: "email",
          type: "text",
          label: "邮箱",
          maxlength: 64,
        },
      ],
      args: {},
      showList: true,
      icon: "fas:copy",
      copyShow: false,
      customerData: {
        mobile: "",
        email: "",
      },
      accountDataText: {
        email: "",
        mobile: "",
      },
    };
  },
  watch: {},
  mounted() {
    this.eGetBase();
  },
  methods: {
    eAddable() {
      this.modalData.addable = true;
      this.modalData.showAdd = true;
    },
    eModalCancel() {
      this.modalData.addable = false;
    },
    eGetBase() {
      this.$$.api.data
        .find(this.url, {
          number: this.$route.params.sn,
          columns: ["*"],
        })
        .then((res) => {
          let argObject = {
            email: res.data.item.email,
            mobile: res.data.item.mobile,
          };
          this.accountDataText = argObject;
          this.modalData.args = argObject;
          this.modalData.name = res.data.item.name;

          this.eGetMessage(res.data.item.userSN);
        });
    },
    eModalConfirm() {
      let args = {};
      args.email = this.modalData.args.email;
      args.mobile = this.modalData.args.mobile;
      args[`${this.type}`] = this.$route.params.sn;
      if (!args.email) {
        args.email = this.accountDataText.email;
      } else if (!args.mobile) {
        args.mobile = this.accountDataText.mobile;
      }
      this.$$.api
        .post(this.addurl, args)
        .then((res) => {
          this.$$.toastr.success("开通成功！");
          this.modalData.formShow = false;
          this.modalData.password = res.data.password;
          this.modalData.mobile = res.data.mobile;
          this.modalData.email = res.data.email;
          this.eGetBase();
        })
        .catch((err) => {
          this.$$.toastr.error(err.message);
        });
    },
    eGetMessage(number) {
      this.$$.api.data
        .find("/kernel/authentication/apis/data/account", {
          columns: [],
          requirement: {
            filters: [{ Name: "userSN", Type: "Equal", Value: number }],
          },
        })
        .then((res) => {
          if (res.data.item) {
            this.showList = false;
            let data = res.data.item;
            this.cusUserSN = data.sn;
            this.accountList.registerTypeText = data.registerType
              ? this.eGetRegisterType(data.registerType)
              : "";
            this.accountList.creatorSNText = data.creatorSN
              ? data.creatorSN
              : "";
            this.accountList.timeText = data.time
              ? this.eGetTime(data.time)
              : "";
            this.accountList.activeStatusText = data.activeStatus
              ? this.eGetActiveStatus(data.activeStatus)
              : "";
            this.accountList.activeTimeText = data.activeTime
              ? this.eGetTime(data.activeTime)
              : "";
            this.accountList.expiredTime = data.expiredTime
              ? this.eGetTime(data.expiredTime)
              : "";
            this.accountList.lastTime = data.lastTime
              ? this.eGetTime(data.lastTime)
              : "";
            this.accountList.account = data.account ? data.account : "";
            this.accountList.mobile = data.mobile ? data.mobile : "";
            this.accountList.email = data.email ? data.email : "";
            this.accountList.passwordComplexityTypeText = data.passwordComplexityType
              ? this.eGetPasswordComplexityType(data.passwordComplexityType)
              : "";
            this.accountList.passwordStatusText = data.passwordStatus
              ? this.eGetPasswordStatus(data.passwordStatus)
              : "";
            this.accountList.passwordTime = data.passwordTime
              ? this.eGetTime(data.passwordTime)
              : "";
            this.accountList.passwordErrorCount =
              data.passwordErrorCount != null ? data.passwordErrorCount : "";
            this.accountList.todayPasswordErrorCount =
              data.todayPasswordErrorCount != null
                ? data.todayPasswordErrorCount
                : "";
            this.accountList.todayPasswordErrorTime = data.todayPasswordErrorTime
              ? this.eGetTime(data.todayPasswordErrorTime)
              : "";
            this.accountList.passwordExpiredTime = data.passwordExpiredTime
              ? this.eGetTime(data.passwordExpiredTime)
              : "";
            this.accountList.passwordModifyTime = data.passwordModifyTime
              ? this.eGetTime(data.passwordModifyTime)
              : "";
            this.accountList.sn = data.sn;
          }
        });
    },
    eGetRegisterType(status) {
      let result = "";
      if (status == "Auto") {
        result = "自动注册";
      } else if (status == "Register") {
        result = "自主注册";
      } else if (status == "Create") {
        result = "后台创建";
      } else {
        result = "未知";
      }
      return result;
    },
    eGetActiveStatus(status) {
      let result = "";
      switch (status) {
        case "Inactive":
          result = { name: "未激活", color: "#9E9E9E" };
          break;
        case "Active":
          result = { name: "已激活", color: "#34C758" };
          break;
        case "Expired":
          result = { name: "已过期", color: "#FF9502" };
          break;
        case "Lock":
          result = { name: "已锁定", color: "#CF1322" };
          break;
        case "Forbidden":
          result = { name: "已停用", color: "#CF1322" };
          break;
        case "Disable":
          result = { name: "已禁用", color: "#9E9E9E" };
          break;
        default:
          result = { name: "未知", color: "#9E9E9E" };
          break;
      }

      return result;
    },
    eGetPasswordComplexityType(status) {
      let result = "";
      switch (status) {
        case "Bad":
          result = "极低";
          break;
        case "Low":
          result = "简单";
          break;
        case "Normal":
          result = "普通";
          break;
        case "High":
          result = "极高";
          break;
        default:
          result = "未知";
          break;
      }
      return result;
    },
    eGetPasswordStatus(status) {
      let result = "";
      switch (status) {
        case "Normal":
          result = "正常";
          break;
        case "Modify":
          result = "需要修改方能进入系统";
          break;
        case "Expired":
          result = "已过期，需要取回";
          break;
        default:
          result = "未知";
      }
      return result;
    },
    eGetTime(time) {
      let result = "";
      let m = moment(time).format("YYYY-MM-DD");
      if (m === "0009-01-01") {
        return result;
      } else if (m === "9999-01-01") {
        return result;
      }
      result = moment(time).format("YYYY-MM-DD");
      // if (result === "0009-01-01") {
      //   return "";
      // } else if (result === "9999-01-01") {
      //   return "";
      // }
      return result;
    },
    eChange() {
      this.addable = true;
      this.showAdd = true;
      this.accountVal = this.accountList.account;
    },
    addCancel() {
      this.addable = false;
    },
    addConfirm() {
      this.$$.api.data
        .modify("/kernel/authentication/apis/data/account", {
          sn: this.cusUserSN,
          item: {
            account: this.accountVal,
          },
        })
        .then(() => {
          this.addable = false;
          this.eGetBase();
        });
    },
    eDisable() {},
    eBan() {
      this.$$.api.data
        .modify("/kernel/authentication/apis/data/account", {
          sn: this.cusUserSN,
          item: {
            activeStatus: "Forbidden",
          },
        })
        .then(() => {
          this.eGetBase();
        });
    },
    eRecovery() {
      this.$$.api.data
        .modify("/kernel/authentication/apis/data/account", {
          sn: this.cusUserSN,
          item: {
            activeStatus: "Active",
          },
        })
        .then(() => {
          this.eGetBase();
        });
    },
    eReset() {
      this.reset.addable = true;
      this.reset.showAdd = true;
      this.reset.formShow = true;
    },
    eResetCancel() {
      this.reset.addable = false;
      this.reset.showAdd = false;
      this.reset.formShow = true;
    },
    eResetConfirm() {
      this.$$.api
        .post("/kernel/authentication/apis/biz/account/password/reset", {
          sn: this.cusUserSN,
        })
        .then((res) => {
          this.reset.password = res.data.password;
          this.reset.formShow = false;
        });
    },
  },
  props: {
    addurl: String,
    url: String,
    addType: String,
    text: String,
    type: String,
  },
};
</script>

<style lang="scss" scoped>
.account_menu_card {
  padding: 5px;
  border-bottom: 1px solid #efefef;
  box-sizing: border-box;
  .account_menu_card-title {
    font-size: 16px;
    color: #333;
  }
  > div {
    padding: 4px 4px;
    color: slategray;
  }
}
.row_flex {
  display: flex;
  > div {
    flex: 1;
  }
  > .row_change {
    color: #6495ed;
    text-align: right;
    > span {
      cursor: pointer;
      margin-left: 5px;
    }
  }
}
.menu_copy {
  cursor: pointer;
  width: 30px;
  height: 30px;
}
.menu_table {
  padding: 8px;
  margin-top: 15px;
  > div {
    font-size: 20px;
    font-weight: 600;
  }
  > th {
    color: #333;
  }
}
</style>